var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultiColorCoingecko = function SvgMultiColorCoingecko(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8DC63F",
    d: "M21.984 11.955a9.984 9.984 0 1 1-19.968.089 9.984 9.984 0 0 1 19.968-.089"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9E988",
    d: "M21.23 11.957a9.233 9.233 0 1 1-18.465.084 9.233 9.233 0 0 1 18.465-.084"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.168 3.366a5 5 0 0 1 1.775 0 5.4 5.4 0 0 1 1.694.568c.526.289.982.681 1.434 1.052.453.37.904.745 1.333 1.157.438.405.82.867 1.136 1.373.326.502.594 1.04.797 1.604a7.3 7.3 0 0 1 .327 3.51h-.06a16.5 16.5 0 0 0-.864-3.299 13 13 0 0 0-.678-1.54 15 15 0 0 0-.899-1.44 5.2 5.2 0 0 0-1.205-1.218c-.468-.333-1.007-.55-1.529-.755a18 18 0 0 0-1.585-.566 20 20 0 0 0-1.674-.387z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BC53F",
    d: "M16.681 8.696c-.67-.194-1.367-.469-2.068-.747-.04-.176-.197-.396-.512-.664-.46-.4-1.323-.389-2.068-.21-.823-.194-1.636-.263-2.42-.075-6.38 1.756-2.761 6.052-5.105 10.365.333.707 3.928 4.839 9.129 3.727 0 0-1.778-4.274 2.235-6.326 3.256-1.67 5.61-4.76.81-6.07"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.47 11.506a.388.388 0 1 1-.776.006.388.388 0 0 1 .776-.006"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#009345",
    d: "M12.031 7.072c.465.034 2.147.583 2.58.877-.358-1.052-1.577-1.188-2.58-.877"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.475 9.725a1.788 1.788 0 1 1-3.576 0 1.788 1.788 0 0 1 3.576 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M11.946 9.74a1.256 1.256 0 1 1-2.513.003 1.256 1.256 0 0 1 2.513-.002"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BC53F",
    d: "M18.916 12.293c-1.446 1.02-3.092 1.788-5.425 1.788-1.092 0-1.313-1.157-2.034-.591-.374.293-1.684.947-2.73.9s-2.735-.661-3.204-2.886c-.186 2.225-.281 3.864-1.117 5.743 1.664 2.664 5.632 4.719 9.231 3.835-.386-2.701 1.975-5.348 3.306-6.702.502-.512 1.472-1.35 1.973-2.091z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M18.859 12.36c-.461.397-.976.726-1.528.98-.55.261-1.125.47-1.715.625-.589.152-1.205.267-1.829.21s-1.262-.27-1.674-.736l.02-.023c.51.329 1.091.445 1.672.461a8 8 0 0 0 1.758-.146 9.6 9.6 0 0 0 1.708-.526 6.4 6.4 0 0 0 1.569-.867z"
  })));
};
export { SvgMultiColorCoingecko as ReactComponent };